import API from '../../../utils/http/api'

// Action Types ===========================================
export const REQUEST = 'steppingblocks/skillsInfo/REQUEST'
export const SUCCESS = 'steppingblocks/skillsInfo/SUCCESS'
export const FAILURE = 'steppingblocks/skillsInfo/FAILURE'

// Reducer ================================================
const initialState = {
  currentSkill: null,
  error: null,
  skillsInfo: null,
  requestEnded: false,
  requestStarted: false,
}

export default (_state = initialState, action) => {
  const { type, payload, currentSkill } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        currentSkill,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        result: payload.result,
        requestEnded: true,
        skillsInfo: {
          ..._state.skillsInfo,
          ...payload
        }
      }
    case FAILURE:
      return {
        ..._state,
        currentSkill,
        error: payload.error,
        requestEnded: true,
      }
    default:
      return _state
  }
}

// Thunks =================================================
export const getSkillInfo = params => async dispatch => {
  dispatch({ type: REQUEST, currentSkill: params.skillName })
  try {
    const data = await API.get(`/resumes/skill-info`, { skillName: params.skillName.toLowerCase() })
    const payload = {}
    payload[params.skillName] = data
    dispatch({
      type: SUCCESS,
      payload,
    })
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message }, currentSkill: params.skillName })
  }
}

// Selectors ==============================================
export const skillsInfo = state => state.skillsInfo && state.skillsInfo.skillsInfo



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/skillsInfoDuck.js